// Content changes for the local preview (become liquid edits when saved to Shopify)
(function () {
  function run() {
    // banner: emoji stars + LCC x Wilder giveaway pill
    var bar = document.querySelector('.bf_announcement_bar > div');
    if (bar) bar.innerHTML = '<p><span class="w-stars">⭐⭐⭐⭐⭐</span>Rated 4.9 by our customers · Free shipping over $190 · Orders dispatched weekly' +
      '<a class="w-lcc" href="https://www.instagram.com/littlechapterclub_/">🎁 Little Chapter Club × Wilder giveaway · ends Fri 20 Nov</a></p>';

    // menu with products
    var items = [
      ['Picnic Baskets', '/search?q=basket&type=product'],
      ['Beach Umbrella', '/products/xl-pistachio-tasseled-umbrella'],
      ['Cushions', '/products/casa-bonita-cushion'],
      ['Blankets', '/products/cosy-blanket-sunny'],
      ['Gift Cards', '/products/wilder-the-label-gift-card'],
      ['Reviews', '/pages/reviews'],
      ['Shop All', '/collections/all']
    ];
    var html = items.map(function (i) { return '<li><a href="' + i[1] + '">' + i[0] + '</a></li>'; }).join('');
    document.querySelectorAll('.bf_nav_menu, .mobilenav-inner > ul').forEach(function (ul) { ul.innerHTML = html; });

    // reviews heading: heart -> stars
    document.querySelectorAll('.owl-testimonials-heading .bf_main_heading').forEach(function (h) {
      h.innerHTML = h.innerHTML.replace(/❤️|❤|♥️?|&#10084;/g, '');
      var img = h.querySelector('img, svg'); if (img) img.remove();
      if (!h.querySelector('.w-bigstars')) h.insertAdjacentHTML('afterbegin', '<span class="w-bigstars">⭐⭐⭐⭐⭐</span>');
    });

    // editorial: eyebrow on cover banner, italic accent word in intro
    document.querySelectorAll('.owl-cover-info').forEach(function (c) {
      if (!c.querySelector('.w-eyebrow')) c.insertAdjacentHTML('afterbegin', '<span class="w-eyebrow">The Wilder Edit</span>');
    });
    document.querySelectorAll('.shopify-section--rich-text .heading.h2').forEach(function (h) {
      if (!h.querySelector('em')) h.innerHTML = h.innerHTML.replace(/(\S+)\s*$/, '<em>$1</em>');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
